import React from 'react';
import AccountMenu from '../AccountMenu';

/**
 * V2PageLayout — khung dùng chung cho các trang quản trị DAT.
 *
 * ── Đổi gì so với bản trước ──
 * Nút "Đăng xuất" rời khỏi thanh tiêu đề, nhường chỗ cho cụm tài khoản
 * (`AccountMenu`): Hồ sơ + Đăng xuất. Tám trang dùng khung này hưởng ngay,
 * không trang nào phải sửa gì.
 *
 * Thêm một khe `queues` nằm dưới thanh lọc, cho cụm hàng đợi chọn-một. Trang
 * nào không truyền thì khe biến mất và bố cục y như cũ — đây là lý do sáu trang
 * còn lại không cần đụng tới.
 *
 * ── Vì sao khung có nền riêng ──
 * Dải khung dùng `--dat-band`, bảng dùng nền trắng. Hai vùng phải nhìn ra là
 * hai thứ khác nhau: bảng là sản phẩm, khung chỉ là chỗ điều khiển. Khung không
 * mang màu trạng thái nào — trong giao diện này màu chỉ để nói đạt hay chưa, và
 * nó chỉ được phép xuất hiện trong bảng.
 *
 * Props (giữ nguyên tên cũ, chỉ thêm `queues`):
 *   title         : ReactNode — tiêu đề trang
 *   queues        : ReactNode — cụm hàng đợi chọn-một (tuỳ chọn)
 *   summary       : ReactNode — dải chỉ tiêu suy ra từ tập kết quả đang xem.
 *                   Nằm NGOÀI dải khung, ngay trên bảng: nó là thứ tính từ dữ
 *                   liệu, không phải chỗ điều khiển, nên không thuộc về khung.
 *   filters       : ReactNode — cụm lọc, bên trái thanh công cụ
 *   actions       : ReactNode — cụm thao tác, bên phải
 *   footer        : ReactNode — phân trang
 *   children      : ReactNode — bảng
 *   gridClassName : string
 */
export default function V2PageLayout({
  title,
  queues,
  summary,
  filters,
  actions,
  footer,
  children,
  gridClassName = 'ag-theme-quartz',
}) {
  return (
    <div className='dat-shell'>
      <div className='dat-band px-3 pt-2 pb-2'>
        <div className='d-flex align-items-center justify-content-between gap-3 mb-2'>
          <h1 className='dat-title text-truncate'>{title}</h1>
          <AccountMenu />
        </div>

        {(filters || actions) && (
          // KHÔNG wrap ở tầng ngoài: để `flex-wrap` ở đây thì cụm thao tác bị
          // đẩy xuống một hàng riêng ngay khi bộ lọc dài ra, ăn thêm ~40px
          // chiều dọc — mà chiều dọc mới là trục khan hiếm trên màn 1366×768,
          // không phải chiều ngang. Bộ lọc tự wrap bên trong; cụm thao tác
          // không co, luôn nằm cùng hàng đầu.
          <div className='d-flex align-items-start gap-2'>
            <div className='d-flex flex-wrap align-items-center gap-2 flex-grow-1'>
              {filters}
            </div>
            {actions && (
              <div className='d-flex align-items-center gap-2 flex-shrink-0'>{actions}</div>
            )}
          </div>
        )}

        {queues && <div className='dat-queues mt-2'>{queues}</div>}
      </div>

      {summary && (
        <div className='px-3 pt-2 flex-shrink-0'>{summary}</div>
      )}

      <div className={`${gridClassName} flex-grow-1 px-3 pt-2`} style={{ minHeight: 0 }}>
        {children}
      </div>

      {footer && (
        <div className='d-flex justify-content-center align-items-center py-2 flex-shrink-0'>
          {footer}
        </div>
      )}
    </div>
  );
}
